const SIDEBAR_SET_ACTIVE_KEY = "page::sidebar::active-key::set";
const HIDE_SIDEBAR = "page::sidebar::hide";

function setActiveKeySidebarAction(activeKey, title, data, storePath) {
  const payload = {
    activeKey,
    title,
    data,
    storePath,
  };

  return {
    payload,
    type: SIDEBAR_SET_ACTIVE_KEY,
  };
}

const hideSidebarAction = {
  payload: {
    activeKey: null,
    title: "",
    data: {},
    storePath: "",
  },
  type: HIDE_SIDEBAR,
};

export {
  setActiveKeySidebarAction,
  SIDEBAR_SET_ACTIVE_KEY,
  HIDE_SIDEBAR,
  hideSidebarAction,
};
